/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../app/components/common/datepicker/datepicker.component';
import * as i2 from '@angular/forms';
import * as i3 from 'ngx-mydatepicker/dist/ngx-my-date-picker.input';
import * as i4 from 'ngx-mydatepicker/dist/services/ngx-my-date-picker.util.service';
import * as i5 from 'ngx-mydatepicker/dist/services/ngx-my-date-picker.config';
const styles_DatePickerComponent:any[] = ([] as any[]);
export const RenderType_DatePickerComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DatePickerComponent,data:{}});
export function View_DatePickerComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{ngxdp:0}),(_l()(),i0.ɵted((null as any),[' '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),6,'div',[['class','input-group']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(16777216,(null as any),
          (null as any),3,'input',[['class','cursor-pointer form-control'],['name',
              'mydate'],['ngx-mydatepicker',''],['placeholder','Select a date'],['readonly',
              'readonly'],['required',''],['style','float:none']],[[8,'name',0]],[[(null as any),
              'click'],[(null as any),'dateChanged'],[(null as any),'keyup'],[(null as any),
              'blur'],['document','click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.DatePickerComponent = _v.component;
            if (('keyup' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,7).onKeyUp($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,7).onBlur()) !== false);
              ad = (pd_1 && ad);
            }
            if (('document:click' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,7).onClick($event)) !== false);
              ad = (pd_2 && ad);
            }
            if (('click' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,7).openCalendar()) !== false);
              ad = (pd_3 && ad);
            }
            if (('dateChanged' === en)) {
              const pd_4:any = ((<any>_co.onDateChanged($event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵprd(5120,(null as any),i2.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.NgxMyDatePickerDirective]),i0.ɵprd(512,(null as any),i4.UtilService,
          i4.UtilService,([] as any[])),i0.ɵdid(540672,[[1,4],['dp',4]],0,i3.NgxMyDatePickerDirective,
          [i4.UtilService,i0.ViewContainerRef,i0.ComponentFactoryResolver,i0.Renderer,
              i0.ChangeDetectorRef,i0.ElementRef,i5.NgxMyDatePickerConfig],{options:[0,
              'options']},{dateChanged:'dateChanged'}),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵted((null as any),[' ']))],(_ck,_v) => {
    var _co:i1.DatePickerComponent = _v.component;
    const currVal_1:any = _co.myOptions;
    _ck(_v,7,0,currVal_1);
  },(_ck,_v) => {
    var _co:i1.DatePickerComponent = _v.component;
    const currVal_0:any = _co.name;
    _ck(_v,4,0,currVal_0);
  });
}
export function View_DatePickerComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'date-picker',
      ([] as any[]),(null as any),(null as any),(null as any),View_DatePickerComponent_0,
      RenderType_DatePickerComponent)),i0.ɵdid(49152,(null as any),0,i1.DatePickerComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const DatePickerComponentNgFactory:i0.ComponentFactory<i1.DatePickerComponent> = i0.ɵccf('date-picker',
    i1.DatePickerComponent,View_DatePickerComponent_Host_0,{name:'name',myOptions:'myOptions'},
    {onDateChange:'onDateChange'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2RhdGVwaWNrZXIvZGF0ZXBpY2tlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2RhdGVwaWNrZXIvZGF0ZXBpY2tlci5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9jb21tb24vZGF0ZXBpY2tlci9kYXRlcGlja2VyLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2RhdGVwaWNrZXIvZGF0ZXBpY2tlci5jb21wb25lbnQudHMuRGF0ZVBpY2tlckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIiA8ZGl2IGNsYXNzPVwiaW5wdXQtZ3JvdXBcIj4gPGlucHV0IGNsYXNzPVwiY3Vyc29yLXBvaW50ZXIgZm9ybS1jb250cm9sXCIgc3R5bGU9XCJmbG9hdDpub25lXCIgcGxhY2Vob2xkZXI9XCJTZWxlY3QgYSBkYXRlXCIgbmd4LW15ZGF0ZXBpY2tlciBuYW1lPVwibXlkYXRlXCIgKGNsaWNrKT1cImRwLm9wZW5DYWxlbmRhcigpXCIgcmVhZG9ubHk9XCJyZWFkb25seVwiIFtvcHRpb25zXT1cIm15T3B0aW9uc1wiICNkcD1cIm5neC1teWRhdGVwaWNrZXJcIiAoZGF0ZUNoYW5nZWQpPVwib25EYXRlQ2hhbmdlZCgkZXZlbnQpXCIgW25hbWVdPVwibmFtZVwiIHJlcXVpcmVkPVwiXCIvPiA8L2Rpdj4gIiwiPGRhdGUtcGlja2VyPjwvZGF0ZS1waWNrZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O21EQ0FBO01BQUM7VUFBQTtNQUF5QixzQ0FBQztVQUFBO2NBQUE7Y0FBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQXlIO2NBQUE7Y0FBQTtZQUFBO1lBQTZGO2NBQUE7Y0FBQTtZQUFBO1lBQXROO1VBQUE7VUFBQTtZQUFBO1VBQUE7eUJBQUEsc0JBQUE7VUFBQTt5RUFBQTtjQUFBLHlDQUF1UjtVQUFBLFFBQU87O0lBQXJIO0lBQXpLLFdBQXlLLFNBQXpLOzs7SUFBNFA7SUFBNVAsV0FBNFAsU0FBNVA7Ozs7b0JDQTNCO01BQUE7b0NBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./compiled/app/components/common/datepicker/datepicker.component.ngfactory.ts